import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ArticleService } from "../article/article.service";
import { Article } from "../article/article";
import { Alert } from "../alert/alert";
import { categories } from "../../assets/categories";
import { environment } from "../../environments/environment";
import { trigger, state, style, animate, transition } from '@angular/animations';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/share';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css']
})
export class DetailsComponent implements OnInit {

  public article:Article;
  public imgUrl:String = environment.urls.img;
  public mainCategories:String[] = categories.main;
  public subCategories:String[];
  public selectedCat:String;
  public soldOut:boolean = false;
  public formData:FormData = new FormData();
  public imgTitle:String;
  public modalState:string = 'hide';

  // Obj to define the alert
  public alert = new Alert('hide', '', '');

  constructor(public route:ActivatedRoute,
              public router:Router,
              private articleService:ArticleService) {
  }

  ngOnInit() {
    let isbn = this.route.snapshot.params['isbn'];

    this.getArticle(isbn);
  }

  onSubmit() {
    this.articleService.updateArticle(this.article)
      .subscribe(res => {
        this.alert.update('show', 'alert-success', 'Artikel wurde erfolgreich aktualisiert');
        this.router.navigate(['overview', this.alert]);
      }, err => {
        if (err.status == 403) {
          this.router.navigate(['login']);
        } else {
          this.alert.update('show', 'alert-danger', err._body);
          window.scrollTo(0, 0);
          setTimeout(()=>this.alert.state = 'hide', 4000);
        }
      });
  }

  public getArticle(isbn):void {
    this.articleService.getArticleDetails(isbn).share().subscribe(article => {
      /*
       * copy article object, so the original one is not directly effected by changes
       * save changes when the 'save' button is triggered
       **/
      this.article = Object.assign({}, article);

      // parse pre-order
      this.parsePreorder(article);

      // parse category
      this.parseCategory(article);
    });
  }

  public updateItem(newVal, itemToChange) {
    if (itemToChange == "category") this.synchScale(newVal);

    this.article[itemToChange] = newVal;
  }

  private synchScale(category):void {
    if (category != 'Kartografie') this.article['scale'] = '0';
  }

  public watchSoldOut(value) {
    this.soldOut = value;
    if (!this.soldOut) {
      this.article.preorder = null;
    }
  }

  public showAlert(event):void {
    this.alert = event;
    setTimeout(()=>this.alert.state = 'hide', 4000);
  }

  public deleteArticle(isbn):void {
    this.articleService.deleteArticle(isbn)
      .subscribe(suc => {
        this.router.navigate(['overview', new Alert('show', 'alert-success', 'Artikel wurder erfolgreich gelöscht')]);
      }, err => {
        this.alert.update('show', 'alert-danger', 'Artikel konnte nicht gelöscht werden');
        setTimeout(() => this.alert.state = 'hide', 4000);
      });
  }

  private parsePreorder(article):void {
    /*
     * check if the pre-order value is set
     * if yes, display the expected publishing date of the refined article
     **/
    if (article.preorder != null) {
      this.soldOut = true;
    } else {
      this.soldOut = false;
    }
  }

  private parseCategory(article):void {
    if (categories.subcategories.books.indexOf(article.category) != -1) {
      this.selectedCat = 'Bücher';
      this.showSubCats(this.selectedCat);
    }

    else if (categories.subcategories.maps.indexOf(article.category) != -1) {
      this.selectedCat = 'Kartografie';
      this.showSubCats(this.selectedCat);
    }

    else {
      this.selectedCat = 'Postkarten';
    }
  }

  public showSubCats(mainCategory) {
    switch (mainCategory) {
      case 'Postkarten':
        this.article.category = mainCategory;
        break;
      case 'Bücher':
        this.subCategories = categories.subcategories.books;
        break;
      case 'Kartografie':
        this.subCategories = categories.subcategories.maps;
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/details/details.component.ts